import React, { useReducer, useCallback, Fragment } from "react";
import Loader from "../loader";

const initialState = {
  selectedCategory: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "fieldChanged": {
      return {
        ...state,
        [action.field]: action.value,
      };
    }

    case "selectedCategoryAdjustmentChanged": {
      return {
        ...state,
        selectedCategory: {
          ...state.selectedCategory,
          adjustment: action.value,
        },
      };
    }

    default:
      break;
  }
  return state;
};

const PeakAdjustments = ({ isLoading, data, isSaving, handleUpdate }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const handleEditCategory = (category) => {
    dispatch({
      type: "fieldChanged",
      field: "selectedCategory",
      value: category,
    });
  };

  const handleEditCategoryCancel = () => {
    dispatch({
      type: "fieldChanged",
      field: "selectedCategory",
      value: null,
    });
  };

  const handleSubmitCategory = useCallback(async () => {
    if (!state.selectedCategory) {
      return;
    }

    const result = await handleUpdate(state.selectedCategory);

    if (result) {
      dispatch({
        type: "fieldChanged",
        field: "selectedCategory",
        value: null,
      });
    }
  }, [state.selectedCategory, handleUpdate]);

  return (
    <div className="peak-adjustments-table position-relative">
      {isLoading && <Loader additionalClasses="position-absolute top-50 start-50 translate-middle z-25" />}

      <table>
        <thead>
        <tr>
          <th colSpan={3}>Peak Adjustments</th>
        </tr>
        </thead>
        <tbody>
        {data.map(category => (
          <tr key={category._id}>
            <td>{category.peakValue}</td>
            <td>
              {state.selectedCategory?._id === category._id ? <input
                type="number"
                name="adjustment"
                step={0.01}
                min={0}
                value={state.selectedCategory.adjustment}
                placeholder="Adjustment %"
                onChange={(e) =>
                  dispatch({
                    type: "selectedCategoryAdjustmentChanged",
                    value: e.target.value,
                  })
                }
              /> : `${(category.adjustment * 100).toFixed(2)}%`}
            </td>
            <td>
              {state.selectedCategory?._id === category._id ?
                <Fragment>
                  <button
                    className="base-button icon-button btn-success"
                    onClick={handleSubmitCategory}
                    disabled={isSaving}
                  >
                    <span className="material-icons">check_circle</span>
                  </button>
                  <button
                    className="base-button icon-button btn-danger ml-2"
                    onClick={handleEditCategoryCancel}
                    disabled={isSaving}
                  >
                    <span className="material-icons">cancel</span>
                  </button>
                </Fragment> :
                <button
                  className="base-button icon-button evo-blue"
                  onClick={() => handleEditCategory(category)}
                  disabled={!!state.selectedCategory && state.selectedCategory._id !== category._id}
                >
                  <span className="material-icons">edit</span>
                </button>}
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};

export default PeakAdjustments;
